import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { useAlert } from 'react-alert'

import { AudienceGroup, AddRequirementGroupSection } from "./RequirementComponents";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import { AudienceCardTitleAndSubtitle } from "./AudienceRequirements";

import { AddRequirementsSideBar, SideBarContent, WalletSideBarContent } from "./SideBar";

// API Calls
import RequirementsAPI from "../../../api/api_calls/RequirementsAPI";
import MissionsAPI from "../../../api/api_calls/MissionAPI";


function UserTypeCard(props) {
    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()

    const [userTypes, setUserTypes] = useState([]);
    const [genPopUserTypes, setGenPopUserTypes] = useState(true);
    const [availableUserTypes, setAvailableUserTypes] = useState([]);
    const [loadingNewUserTypes, setLoadingNewUserTypes] = useState(true);
    const [loadingUserTypes, setLoadingUserTypes] = useState(true);
    const [submitInProcess, setSubmitInProcess] = useState(false);

    async function getUserTypes() {
        const result = await RequirementsAPI.indexUserTypes(missionId, navigate);

        if (result.success) {
            setUserTypes(result.user_types);
            determineGenPopUserTypes(result.user_types);
            setLoadingUserTypes(false);
        } else {
            alert.error("Failed to get user types");
        }

    }

    useEffect(() => {
        // Enable tooltips
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

        // So what we want back here ( per requirement group)
        // A list that matches the ordering of the new requirements
        // So it comes back with 

        async function getNewUserTypes() {
            const result = await RequirementsAPI.newUserType(missionId, navigate);

            if (result.success) {
                setAvailableUserTypes(result.available_user_types);
                setLoadingNewUserTypes(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        // async function getSessionDetails() {
        //     const result = await MissionsAPI.show(missionId, navigate);

        //     if (result.success) {
        //         if (result.mission.num_total_spots != null) {
        //             setTotalMissionSpots(result.mission.num_total_spots * 1);
        //         }
        //     } else {
        //         alert.show(result.error, { type: 'error' })
        //     }
        // }

        getUserTypes();
        getNewUserTypes();
        // getSessionDetails();
    }, []);

    function determineGenPopUserTypes(userTypes) {
        // If ALL user types are false, then genPopUserTypes should be true
        // Else, its' false.
        let allFalse = true;
        for (const key in userTypes) {
            if (userTypes[key].value === true) {
                allFalse = false;
                break;
            }
        }
        setGenPopUserTypes(allFalse);
    }

    function toggleUserType(userType) {
        console.log("Toggling user type: " + userType)
        // Update userTypes to have the new value
        const newUserTypes = { ...userTypes };
        newUserTypes[userType].value = !newUserTypes[userType].value;

        // Determine if genPopUserTypes should be true or false
        determineGenPopUserTypes(newUserTypes);

        setUserTypes(newUserTypes);
        updateUserTypesOnBackend({ [userType]: newUserTypes[userType].value });
        updatePriceDebounce();
    }

    function toggleGenPopUserType() {
        console.log("Toggling gen pop user type")
        // If we're toggling it to become true, then we need to set all user types to false
        // If toggling to become false, pop an alert instead.
        if (genPopUserTypes === true) {
            alert.show("Select User Types to include", { type: 'error' })
            return;
        }

        // Update userTypes to have the new value
        const newUserTypes = { ...userTypes };
        for (const key in newUserTypes) {
            newUserTypes[key].value = false;
        }

        setGenPopUserTypes(true);
        setUserTypes(newUserTypes);
        destroyAllUserTypesOnBackend();
        updatePriceDebounce();
    }

    // Create a debounced version of the update function
    // This will only update the server every 500ms
    const updatePriceDebounce = useCallback(
        _.debounce(props.updatePrice, 500), [] // 500ms debounce
    );

    async function updateUserTypesOnBackend(userTypeUpdate) {
        console.log("Updating server with data:", userTypeUpdate);
        const result = await RequirementsAPI.updateUserType(missionId, userTypeUpdate, navigate);

        if (result.success) {
        } else {
            alert.show(result.error, { type: 'error' })
        }
        setSubmitInProcess(false);
    }

    async function destroyAllUserTypesOnBackend() {
        console.log("Destroying all user types on backend")
        const result = await RequirementsAPI.destroyAllUserTypes(missionId, navigate);

        if (result.success) {
        } else {
            alert.show(result.error, { type: 'error' })
        }
        setSubmitInProcess(false);
    }

    return (
        <div className="audience-requirements-card">
            <AudienceCardTitleAndSubtitle title="User Type" subtitle="Narrow your audience by targeting specific types of users." />
            <div className="audience-requirements-req-cards-list">
                {loadingNewUserTypes || loadingUserTypes ? <CenteredLoadingIcon /> :
                    <div className="user-type-content-container">
                        <div className="user-type-section-content">
                            <div className="user-type-section-title">Target the general population</div>
                            <div className="user-type-checkbox-small-grid">
                                <UserTypeCheckBox key="gen_pop_checkbox" label="All User Types" value={genPopUserTypes} toggleCheckBox={() => toggleGenPopUserType()} />
                            </div>
                        </div>
                        <div className="user-type-section-content">
                            <div className="user-type-section-title">Narrow to specific types of users</div>
                            <div className="user-type-checkbox-grid">
                                {Object.keys(availableUserTypes)
                                    .reduce((resultArray, item, index) => {
                                        const chunkIndex = Math.floor(index / 4);

                                        if (!resultArray[chunkIndex]) {
                                            resultArray[chunkIndex] = []; // Start a new chunk
                                        }

                                        resultArray[chunkIndex].push(item);

                                        return resultArray;
                                    }, [])
                                    .map((group, groupIndex) => (
                                        <div key={`group_${groupIndex}`} className="user-type-checkbox-column">
                                            {group.map((key) => {
                                                const tempValue = userTypes[key].value;

                                                return (
                                                    <UserTypeCheckBox
                                                        key={"checkbox_row" + key}
                                                        label={availableUserTypes[key]}
                                                        value={tempValue} toggleCheckBox={() => toggleUserType(key)}
                                                        updatePrice={props.updatePrice}
                                                    />
                                                );
                                            })}
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )

}

function UserTypeCheckBox(props) {
    const labelClass = props.value === true ? "user-type-checkbox-label checked" : "user-type-checkbox-label"

    return (
        <div className="user-type-checkbox-container">
            <input className="user-type-checkbox-color"
                id={props.label}
                type='checkbox'
                name={props.label}
                // value={props.value}
                onChange={props.toggleCheckBox}
                checked={props.value}
            />
            <label className={labelClass} htmlFor={props.label}>
                {props.label}
            </label>
        </div>
    )
}


export default UserTypeCard;